import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoaderButton from '../loader-button/LoaderButton';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup } from 'reactstrap';
import { FieldGroup } from '../../libs/formLib';

const InputModal = ({
  modalOpen,
  isReadOnly,
  setModalOpen,
  loader,
  createKey,
  cta,
  setKeyName,
  keyName,
  isSubmitted,
  setIsSubmitted
}) => {
  useEffect(() => {
    setIsSubmitted(false);
  }, [setIsSubmitted]);
  const open = () => {
    setKeyName('');
    setIsSubmitted(false);
    setModalOpen(!modalOpen);
  };

  return (
    <Fragment>
      <Button
        color="falcon-primary"
        disabled={isReadOnly}
        className="btn-sm"
        onClick={() => open()}
        data-testid={'input-modal-cta'}
      >
        {cta}
      </Button>
      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader>API Key Creation</ModalHeader>
        <ModalBody>
          <FormGroup lg="5">
            <FieldGroup
              type="text"
              label="Key Name"
              id="keyName"
              onChange={e => setKeyName(e.target.value)}
              value={keyName}
              placeholder="key name..."
              help="Choose the name for your API key"
              required
              feedback="Please specify a valid key name"
              showFeedback={keyName?.replace(/\s+/g, '').length === 0 && isSubmitted}
              data-testid={'key-name'}
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <>
            <Button color="falcon-danger" onClick={() => setModalOpen(!modalOpen)} data-testid={'cancel-btn'}>
              Cancel
            </Button>
            <LoaderButton
              color="falcon-primary"
              // onClick={fields.name > 1 ? createKey(fields.name) : null}
              onClick={e => (keyName.replace(/\s+/g, '').length > 1 ? createKey() : setIsSubmitted(true))}
              isLoading={loader}
              name="save-and-add"
            >
              {cta}
            </LoaderButton>
          </>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

InputModal.propTypes = {
  isLoading: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  handleSave: PropTypes.func,
  setModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  createKey: PropTypes.func,
  keyName: PropTypes.string,
  loader: PropTypes.bool,
  cta: PropTypes.string,
  isSubmitted: PropTypes.bool,
  setKeyName: PropTypes.func,
  setIsSubmitted: PropTypes.func
};

export default InputModal;
